// Copy this into the array below to add a new note.
// Markdown file goes at public/markdown/blog/notes/<slug>.md (filename must match slug).
// {
//   title: 'Some evergreen topic',
//   slug: 'some-evergreen-topic',
//   updated: '2026-08-24',
//   excerpt: 'One-line summary shown in the list and used for search.',
//   tags: ['Tag One', 'Tag Two'],
// },

const data = [];

export default data;
